import type {OrgEditPermissions} from '@github-ui/custom-properties-types'
import {propertyDefinitionSettingsPath} from '@github-ui/paths'
import {useSearchParams} from '@github-ui/use-navigate'

import {type PropertiesPageTabName, validTabOrDefault} from '../components/PropertiesPageTabs'
import {useCurrentOrg} from '../contexts/CurrentOrgRepoContext'

export function useActiveTab(
  permissions: OrgEditPermissions,
): [PropertiesPageTabName, (tab: PropertiesPageTabName) => string] {
  const {login: org} = useCurrentOrg()
  const [params] = useSearchParams()

  function hrefBuilder(tab: PropertiesPageTabName): string {
    const newParams = new URLSearchParams(params)
    newParams.set('tab', tab)
    return `${propertyDefinitionSettingsPath({org})}?${newParams.toString()}`
  }

  return [validTabOrDefault(params.get('tab'), permissions), hrefBuilder]
}
